import { FunctionComponent } from "react"
import { Button, Card } from "react-bootstrap"
import { useNavigate } from "react-router-dom"

interface IDoorsCard {}
const DoorsCard: FunctionComponent<IDoorsCard> = () => {
	const navigate = useNavigate()
	return (
		<Card className="mt-4">
			<Card.Header>Doors & Access Controllers</Card.Header>
			<Card.Body>
				<Card.Text>
					<ul>
						<li>Add or replace an access controller</li>
						<li>Rename a door</li>
						<li>Disable a card reader</li>
						<li>Hold a door open</li>
					</ul>
					<Button className="mt-4" onClick={() => navigate("/doors")}>
						View Doors
					</Button>
					<br />
					<Button className="mt-4" onClick={() => navigate("/access-controllers")}>
						View Access Controllers
					</Button>
				</Card.Text>
			</Card.Body>
		</Card>
	)
}
export default DoorsCard
